import "@/styles/pages/blogs.scss";
import { useEffect, useState } from "react";
import CardComponent from "@/components/card";
import BackWithLabel from "@/components/common/BackWithLabel";
import MainHeading from "@/components/heading/MainHeading";
import Wrapper from "@/layout/Wrapper";
import { DeleteItem, GetList } from "@/services/customHelperRequests";
import { Card, Col, Flex, Pagination, Popover, Row } from "antd";
import { IconDotsBlog, UpperRightArrow } from "@/components/icons/others/icons";
import ButtonComponent from "@/components/button/Button";
import IconEdit from "@/components/icons/IconEdit";
import IconDelete from "@/components/icons/IconDelete";
import { useDispatch, useSelector } from "react-redux";
import { refreshContent, setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useNavigate } from "react-router-dom";
import SearchBar from "@/components/input/SearchBar";
import "@/pages/blogs/create-blogs";
import SEOHead from "@/components/SEO/SEOHead";

const useGetContentReload = () => {
  let refreshcontent = useSelector((state) => state?.common?.refreshcontent);
  return refreshcontent;
};

const handleDelete = (id, dispatch) => {
  DeleteItem(`adminApi/blog/${id}`)
    .then((res) => {
      dispatch(setCurrentForm("successModal"));
      dispatch(setFormProps({ message: "Blog Deleted successfully." }));
      dispatch(refreshContent());
    })
    .catch((err) => console.log(err));
};

const RecentBlogs = () => {
  const [blogs, setblogs] = useState(null);
  const [blogscount, setblogscount] = useState(0);
  const [popopen, ispopopen] = useState();
  const dispatch = useDispatch();
  const [page, setpage] = useState(1);
  const refreshcontent = useGetContentReload();
  const navigate = useNavigate();
  const [search_blog, set_search_blog] = useState("");

  const blogCardStyle = {
    color: "white",
    border: "1.58828px solid #E9E9E9",
    height: "200px",
    filter: "drop-shadow(0px 0.79414px 2.54125px rgba(0, 0, 0, 0.16))",
    "border-radius": "12.7062px",
    "background-size": "cover",
  };

  useEffect(() => {
    GetList(`/adminApi/blog?page=${page}&search=${search_blog}`).then((res) => {
      setblogs(res?.rows);
      setblogscount(res?.count);
    });
  }, [refreshcontent, page, search_blog]);

  const handleSearch = (value) => {
    set_search_blog(value);
  };
  
  // Generate SEO description for recent blogs page
  const generateRecentBlogsDescription = () => {
    if (!blogs || blogs.length === 0) {
      return "Manage and view your recent blog posts in one convenient location. Add, edit, or remove blog content.";
    }
    
    return "Access and manage your recent blog publications. Review, edit, and organize your content efficiently.";
  };
  
  // Extract keywords from all blogs
  const extractRecentBlogsKeywords = () => {
    if (!blogs || blogs.length === 0) return "blogs, content management, recent blogs, blog dashboard";
    
    // Get keywords from first 5 blogs if available
    const keywordSets = blogs
      .slice(0, 5)
      .map(blog => blog.keywords || []);
      
    // Flatten and remove duplicates
    const uniqueKeywords = Array.from(new Set(keywordSets.flat()));
    
    // Add default keywords
    const defaultKeywords = ["recent blogs", "blog management", "content dashboard"];
    
    // Combine all keywords and limit
    return [...uniqueKeywords, ...defaultKeywords].slice(0, 10).join(", ");
  };
  
  // Get the base URL from the environment or use a default
  const baseUrl = import.meta.env.VITE_URL || window.location.origin;
  const blogPageUrl = `${baseUrl}/recent-blogs`;
  
  // Get featured image for OG image (first blog's image or a default)
  const featuredImage = 
    blogs && blogs.length > 0 && blogs[0].coverImage
      ? blogs[0].coverImage 
      : `${baseUrl}/assets/images/blogHeaderIcon.svg`;

  return (
    <Wrapper>
      <SEOHead
        title="Recent Blogs | Admin Dashboard"
        description={generateRecentBlogsDescription()}
        keywords={extractRecentBlogsKeywords()}
        ogTitle="Recent Blogs | Admin Dashboard"
        ogDescription={generateRecentBlogsDescription()}
        ogImage={featuredImage}
        ogUrl={blogPageUrl}
        ogType="website"
      />
      <div className="container">
        <MainHeading title="Blogs" />
        <SearchBar onSearch={handleSearch} />
        <CardComponent className="recentblogs">
          <Flex justify="space-between" align="between">
            <BackWithLabel path="/create-blog" label={"Recent Blogs"} />
            <ButtonComponent
              onClick={() => {
                dispatch(setFormProps({}));
                navigate("/create-blog");
              }}
              type="default"
              label="+ Add New Blog"
              style={{ width: "200px" }}
            />
          </Flex>

          <br></br>
          <div className="recentblogslist">
            <Row gutter={[16, 16]}>
              {blogs?.map((blog_item, index) => (
                <Col span={12} key={index}>
                  <Card
                    className={`blogCard ${blog_item?.isFeatured ? "blogCardIsFeatured" : ""}`}
                    style={{
                      background: blog_item?.isDeleted
                        ? `linear-gradient(#919299d4 100%, rgba(246, 238, 238, 0.65) 0%, url(${
                            blog_item?.coverImage || "https://random.imagecdn.app/500/150"
                          }) center/cover no-repeat`
                        : `linear-gradient(to bottom, rgba(7, 7, 7, 0.4) 100%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.65) 100%), url(${
                            blog_item?.coverImage || "https://random.imagecdn.app/500/150"
                          }) center/cover no-repeat`,
                      ...blogCardStyle,
                    }}
                  >
                    <Flex vertical className="h-100" align="space-between" justify="space-between">
                      <Flex justify="end">
                        <div className="threedotmenu">
                          <Popover
                            placement="bottomRight"
                            content={
                              <div className="menulink-popover">
                                <ButtonComponent
                                  size="small"
                                  className="p-0 m-0"
                                  varient="text"
                                  onClick={() => {
                                    ispopopen("");
                                    dispatch(setFormProps({ data: blog_item }));
                                    navigate("/create-blog");
                                  }}
                                >
                                  <IconEdit />
                                  <span>Edit Blog</span>
                                </ButtonComponent>
                                <ButtonComponent
                                  size="small"
                                  varient="text"
                                  className="m-0 p-0"
                                  onClick={() => {
                                    ispopopen("");
                                    dispatch(setCurrentForm("confirmDelete"));
                                    dispatch(setModalOpen(true));
                                    dispatch(
                                      setFormProps({
                                        onSubmit: () => handleDelete(blog_item?.id, dispatch),
                                      })
                                    );
                                  }}
                                >
                                  <IconDelete />
                                  <span>Delete Blog</span>
                                </ButtonComponent>
                              </div>
                            }
                            open={popopen === index}
                            trigger="click"
                            onOpenChange={() => {
                              popopen !== "" ? ispopopen("") : ispopopen(index);
                            }}
                          >
                            <IconDotsBlog className="cursor-pointer" />
                          </Popover>
                        </div>
                      </Flex>

                      <Flex justify="space-between" align="flex-end">
                        <Flex vertical align="start" justify="center">
                          <h4 className="p-0 m-0 blogcarddate">
                            {new Date(blog_item?.updatedAt).toDateString()}
                          </h4>
                          <h4 className="p-0 m-0 blogcarddatetitle">
                            {blog_item?.title?.length > 300
                              ? String(blog_item?.title)?.slice(0, 300) + "..."
                              : String(blog_item?.title)}
                          </h4>
                        </Flex>
                        <div className="upperrightarrow">
                          <a
                            target="_blank"
                            href={`${import.meta.env.VITE_URL}blogs/${blog_item?.id}`}
                            rel="noreferrer"
                          >
                            {" "}
                            <UpperRightArrow />
                          </a>
                        </div>
                      </Flex>
                    </Flex>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
          <br />
          <Pagination onChange={(e) => setpage(e)} defaultCurrent={page} total={blogscount} />
        </CardComponent>
      </div>
    </Wrapper>
  );
};

// {
//     "id": "075be00c-fe06-4568-ab28-11e00d0e4482",
//     "title": "The Importance of Learning Programming",
//     "content": "In today's digital age, learning programming is essential for anyone looking to thrive in technology-related fields. From software development to data science, the skills learned through coding can open doors to numerous career opportunities. Programming also encourages logical thinking and problem-solving, making it a valuable skill for anyone to have, regardless of their career path.",
//     "fileName": "string",
//     "authorName": "Jane Doe",
//     "updatedAt": "2024-11-25T15:21:40.892Z",
//     "fileKey": "string",
//     "coverImage": "https://nm1ecs.yotta.com:9021/inforens_global_bkt/01ARZ3NDEKTSV4RRFFQ69G5FAV/string?AWSAccessKeyId=inforens_global_user&Expires=1736036972&Signature=OW6FLnxwivF1ev%2FLU%2BU57yTwWGo%3D"
// }

export { RecentBlogs };
